import React, { useState } from 'react'
import { Panel, Row, Col, Input, SelectPicker, DatePicker } from 'rsuite'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import moment from 'moment'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'

export default function ClosureApproveRequestSearchForm({
  schema,
  loading,
  onSearch = () => {},
  ...props
}) {
  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()

  const [closureDocNo, setClosureDocNo] = useState()
  const [closureStatus, setClosureStatus] = useState()
  const [closureType, setClosureType] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.projectCode.label}
            <Input
              placeholder={schema.projectCode.hint || schema.projectCode.label}
              value={projectCode}
              onChange={(value) => {
                setProjectCode(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.projectName.label}
            <Input
              placeholder={schema.projectName.hint || schema.projectName.label}
              value={projectName}
              onChange={(value) => {
                setProjectName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.closureDocNo.label}
            <Input
              placeholder={schema.closureDocNo.hint || schema.closureDocNo.label}
              value={closureDocNo}
              onChange={(value) => {
                setClosureDocNo(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.closureType.label}
            <SelectPicker
              searchable={false}
              data={schema.closureType.options}
              value={closureType}
              block
              placeholder={`เลือก${schema.closureType.label || ''}`}
              onChange={(value) => {
                setClosureType(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.startDate.label}
            <DatePickerCustom 
              {...props}
              placement="auto"
              value={startDate}
              disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
              onChange={(value) => {
                setStartDate(value)
              }}
            />
            {/* <DatePicker
              format={DATE_PICKER_FORMAT}
              locale={LOCAL_DAY_TH}
              block
              oneTap
              value={startDate}
              disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
              onChange={(value) => {
                setStartDate(value)
              }}
            /> */}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.endDate.label}
            <DatePickerCustom 
              {...props}
              placement="auto"
              value={endDate}
              disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
              onChange={(value) => {
                setEndDate(value)
              }}
            />
            {/* <DatePicker
              format={DATE_PICKER_FORMAT}
              locale={LOCAL_DAY_TH}
              block
              oneTap
              value={endDate}
              disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
              onChange={(value) => {
                setEndDate(value)
              }}
            /> */}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.closureStatus.label}
            <SelectPicker
              searchable={false}
              data={schema.closureStatus.options}
              value={closureStatus}
              block
              placeholder={`เลือก${schema.closureStatus.label || ''}`}
              onChange={(value) => {
                setClosureStatus(value)
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                let request = {
                  projectCode: projectCode,
                  projectName: projectName,
                  startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
                  endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
                  closureStatus: closureStatus,
                  closureType: closureType,
                  closureDocNo: closureDocNo,
                }
                onSearch(request)
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                setProjectCode('')
                setProjectName('')
                setClosureDocNo('')
                setClosureStatus('')
                setClosureType('')
                setStartDate(null)
                setEndDate(null)

                onSearch({})
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
